import CommunitiesOverviewContainer from "../../Containers/CommunitiesOverview";

const CommunitiesOverview = () => {
  return <CommunitiesOverviewContainer />;
};

export default CommunitiesOverview;
